export const EXCMCUSTOMFIELDVALUE_CREATE_RESET = 'EXCMCUSTOMFIELDVALUE_CREATE_RESET'
export const EXCMCUSTOMFIELDVALUE_CREATE_SET_CREATED = 'EXCMCUSTOMFIELDVALUE_CREATE_SET_CREATED'
export const EXCMCUSTOMFIELDVALUE_CREATE_SET_ERROR = 'EXCMCUSTOMFIELDVALUE_CREATE_SET_ERROR'
export const EXCMCUSTOMFIELDVALUE_CREATE_SET_VIOLATIONS = 'EXCMCUSTOMFIELDVALUE_CREATE_SET_VIOLATIONS'
export const EXCMCUSTOMFIELDVALUE_CREATE_TOGGLE_LOADING = 'EXCMCUSTOMFIELDVALUE_CREATE_TOGGLE_LOADING'
